import React, {  } from 'react'

import * as Collapsible from '@radix-ui/react-collapsible'

import { InfoCircle } from 'react-bootstrap-icons'

import { InputDescription } from '../InputDescription/InputDescription'
import { Label } from '../Label/Label'

import { FormInputProps } from './FormInput.types'

import './FormInput.scss'

export const FormInput: React.FC<FormInputProps> = ({ 
  name,
  description,
  errorMessage,
  hidden,
  children
}) => {  

  return (
    hidden ? 
      <>{children}</>
      :
      <Collapsible.Root
        style={{
          display: 'flex',
          flexDirection: 'column',
          fontSize: 'inherit',
          color: 'inherit',
          gap: 2
        }}
      >
        <Label 
          label={
            <div
              style={{
                display: 'flex',
                fontSize: 'inherit',
                alignItems: 'center',
                gap: 8,
                color: errorMessage ? 'red' : 'inherit',
              }}
            >
              {(name.charAt(0).toUpperCase() + name.slice(1)).split('-').join(' ')}
              {errorMessage && <>{` ${errorMessage}.`}</>}
              <Collapsible.Trigger
                style={{
                  backgroundColor: 'rgba(0,0,0,0)',
                  borderRadius: 999,
                  border: 'none',
                  width: 12,
                  height: 12,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor:'pointer',
                  padding: 0,
                }}
              >
                <InfoCircle style={{ fill: errorMessage ? 'red' : 'var(--primary)' }}/>
              </Collapsible.Trigger>
            </div>
          }
        > 
          <InputDescription 
            helpText={
              <Collapsible.Content className='collapse-content'>
                {description}
              </Collapsible.Content>
            }
          >
            {children}
          </InputDescription>
        </Label>
      </Collapsible.Root>
  )
}

export default FormInput